// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"703":"37165450","835":"4fda9d8e","939":"821a6a2e","972":"ba436d39"}[chunkId] + ".chunk.css";
};